module.exports = __webpack_public_path__ + "img/farewell_5.d0bc8ba7.jpg";